export const STATUS_INITIAL = 'status.initial';
export const STATUS_LOADING = 'status.loading';
export const STATUS_LOADED = 'status.loaded';
export const STATUS_FAILED = 'status.failed';
